import React from 'react';

const Footer = () => (
  <footer className="w-full h-6 bg-gray-700 flex justify-center items-center text-white text-xs">
    © {new Date().getFullYear()} Houval. All rights reserved.
  </footer>
);

export default Footer;
